<cp-widget [errorList]="inputQuantity?.errorList" [isHideLoading]="isHideLoading" [idGraphic]="1">
  <div class="po-row cp-text-center np" style="margin-top: 1em;">
    <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-text-center" style="width: fit-content">
      <span class="cp-font-bold" style="font-size: 14px;">{{ literalsCp?.strSaldo }}</span>
      <span class="cp-div-rectangle" style="margin-top: 1em; margin-left: 7px;">
        <span style="font-size: 14px;"> {{ literalsCp?.strUnidade }} | {{ this.inputQuantity.unitOfMeasure }}</span>
      </span>
    </div>
  </div>

  <div class="po-row cp-text-center ">
    <span class="cp-text-color cp-font-normal" style="font-size: 30px; margin-top: 0.5em;">{{ inputItem.getFormattedNumber(this.inputQuantity.inputQuantityBalance) }}</span>
  </div>

  <div class="po-row cp-text-center ">
    <span class="cp-font-bold" style="font-size: 11px;"> {{ calculoSaldoInsumo }} </span>
  </div>
</cp-widget>
